import React from 'react';
import { Flex } from '../base/layout-components';
import Text from '../base/Text';
import FlameIcon from 'images/icons/flame.svg';
import { Tooltip } from '@material-ui/core';

const Burnout = ({ name }) => {
  return (
    <Tooltip
      title={
        <Flex padding='tooltip' direction='column'>
          <Flex items='center' pb='small'>
            <img src={FlameIcon} alt='' />
            <Text pl='0.5rem' size='medium' weight={500} color='shark'>
              Burnout Alert!
            </Text>
          </Flex>
          <Text color='shuttleGray' size='medium'>
            Is {name} taking time to rest? Check in with them.
          </Text>
        </Flex>
      }
    >
      <img src={FlameIcon} alt='' />
    </Tooltip>
  );
};

export default Burnout;
